export default "__VITE_ASSET__B$SfPb3p__"